import {formQuery} from '@pluto/rest';
import {History} from 'history';

export type SetQuery<T extends unknown> = (
    history: History,
    route: string,
    params: T
) => void;

export const setQuery = <T extends unknown>(
    history: History,
    pathname: string,
    params: T
) => {
    const search = formQuery('', params);

    window.history.replaceState('', '', `${pathname}${search}`);

    // replace router history with window history in order to prevent unnecessary re-render 'AppRouterContainer' component

    // history.push({
    //     pathname,
    //     search,
    // });
};
